import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class GetUnreadNotificationsQuantityWebService {
  constructor(private handler: BaseHandler) {}

  execute(token: string): Observable<number> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.GET_UNREAD_NOTIFCATIONS_ENDPOINT())
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((res) => res.notifications));
  }
}
